<script setup>
import { computed } from 'vue';

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  },
  selectedLocation: {
    type: String,
    default: ''
  },
  availableLocations: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:modelValue', 'update:selectedLocation']);

const pickUpInStore = computed({
  get: () => props.modelValue,
  set: (value) => emit('update:modelValue', value)
});

const selectedPickupLocation = computed({
  get: () => props.selectedLocation,
  set: (value) => emit('update:selectedLocation', value)
});
</script>

<template>
  <div class="mb-4">
    <div class="flex items-center justify-between mb-3">
      <div class="flex items-center gap-2">
        <i class="pi pi-shopping-bag text-gray-600" style="font-size: 18px;"></i>
        <div>
          <label class="block text-sm font-medium text-gray-700">Pick Up In Store</label>
          <p class="text-xs text-gray-500">Customer will pick up order at POS location.</p>
        </div>
      </div>
      <input v-model="pickUpInStore" type="checkbox" class="toggle" />
    </div>

    <div v-if="pickUpInStore" class="space-y-3 mt-4 pl-8">
      <div>
        <label class="block text-sm font-medium text-gray-700 mb-2">Pickup Location</label>
        <select v-model="selectedPickupLocation"
          class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:border-transparent">
          <option v-for="location in availableLocations" :key="location.value"
            :value="location.value">
            {{ location.label }}
          </option>
        </select>
        <p class="text-xs text-gray-500 mt-1">Select the POS profile location for pickup</p>
      </div>
    </div>
  </div>
</template>

<style scoped>

input.toggle:checked {
  background-color: #a855f7 ;
}
</style>
